import { useRecordContext } from 'react-admin';
import { Avatar } from 'shared/mui/Avatars';
import { Chip } from 'shared/mui/Chips';
import { Role } from 'types/embedded/role';

type RoleNameFieldProps = {
  label?: string;
  cellClassName?: string;
};

export const RoleNameField: React.FC<RoleNameFieldProps> = () => {
  const record = useRecordContext<Role>();

  return (
    <Chip avatar={<Avatar src={record?.roleCategories?.description} />} label={record?.name} />
  );
};
